import { useQuery } from '@tanstack/react-query';
import { get } from './api';
import API_ROUTES from './routes';

const getDevRevSessionToken = async () => {
	const res = await get<string>(API_ROUTES.supportSessionToken);
	return res.data;
};

export const useDevRevSessionToken = () =>
	useQuery(['devRevSessionToken'], getDevRevSessionToken, {
		staleTime: Infinity,
		enabled: true
	});
